import { createActionType } from 'app/store/utils';

const type = createActionType('dataset');

export const INVALIDATE_DATASET = type('InvalidateDataset');
export const INVALIDATE_DOWNSTREAM_DATASETS = type('InvalidateDownstreamDatasets');
